var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8501 7.94999C18.8501 6.37517 17.5749 5.09999 16.0001 5.09999C14.4253 5.09999 13.1501 6.37517 13.1501 7.94999C13.1501 9.52481 14.4253 10.8 16.0001 10.8C17.5749 10.8 18.8501 9.52481 18.8501 7.94999ZM20.6501 7.94999C20.6501 10.5189 18.569 12.6 16.0001 12.6C13.4312 12.6 11.3501 10.5189 11.3501 7.94999C11.3501 5.38106 13.4312 3.29999 16.0001 3.29999C18.569 3.29999 20.6501 5.38106 20.6501 7.94999ZM9.9001 18.4286C9.9001 19.1974 9.80933 19.1 10.2354 19.1H21.7648C22.1909 19.1 22.1001 19.1974 22.1001 18.4286C22.1001 16.536 19.3219 15.4 16.0001 15.4C12.6783 15.4 9.9001 16.536 9.9001 18.4286ZM16.0001 13.6C20.2273 13.6 23.9001 15.1018 23.9001 18.4286C23.9001 20.1642 23.2146 20.9 21.7648 20.9H10.2354C8.78563 20.9 8.1001 20.1642 8.1001 18.4286C8.1001 15.1018 11.7729 13.6 16.0001 13.6ZM9.63649 8.86359C9.98797 9.21506 9.98797 9.78491 9.63649 10.1364L4.63649 15.1364C4.28502 15.4879 3.71517 15.4879 3.3637 15.1364L0.863702 12.6364C0.51223 12.2849 0.51223 11.7151 0.863702 11.3636C1.21517 11.0121 1.78502 11.0121 2.13649 11.3636L4.0001 13.2272L8.3637 8.86359C8.71517 8.51212 9.28502 8.51212 9.63649 8.86359Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddedOutline);
export default __webpack_public_path__ + "static/media/user_added_outline.a7166d02b1630db1b853a06ce986e0b8.svg";
export { ForwardRef as ReactComponent };